import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PanelTab } from '../video-detail-panel';

/** Tabs beside the player. The page projects the Up next list and the comments into the two slots. */
@Component({
  selector: 'app-vd-side-panel',
  templateUrl: './vd-side-panel.component.html',
})
export class VdSidePanelComponent {
  @Input() tab: PanelTab = 'next';
  @Input() showComments = false;
  @Input() commentCount = 0;
  @Output() tabChange = new EventEmitter<PanelTab>();

  select(tab: PanelTab): void {
    if (tab !== this.tab) this.tabChange.emit(tab);
  }
}
